<template>
    <div>
        <vue-hcaptcha
            ref="captcha"
            sitekey="f792226a-0434-473e-8356-fbcc85c8ab5e"
            @verify="verified"
            @expired="expired"
            @open="opened"
        />
    </div>
</template>

<script>
import VueHcaptcha from "@hcaptcha/vue-hcaptcha";

export default {
    methods: {
        opened() {
            // this.$plausible("captchaPrompted", {
            //     props: {
            //         vendor: "hcaptcha",
            //         analyticsKey: this.analyticsKey,
            //     },
            // });
        },
        verified(token) {
            // this.$plausible("captchaSuccess", {
            //     props: {
            //         vendor: "hcaptcha",
            //         analyticsKey: this.analyticsKey,
            //     },
            // });

            this.api
                .post("/fortress/captcha/nonce", {
                    "h-captcha-response": token,
                    key: this.uniqueKey,
                })
                .then((response) => {
                    this.$emit("verified", response?.data?.nonce);
                });
        },
        expired() {
            // this.$plausible("captchaExpired", {
            //     props: {
            //         vendor: "hcaptcha",
            //         analyticsKey: this.analyticsKey,
            //     },
            // });

            this.$refs.captcha.reset();
        },
    },
    components: {
        VueHcaptcha,
    },
    props: ["uniqueKey", "analyticsKey"],
};
</script>
